import React from 'react';

// import deleteIcon from '../../../images/icons/delete.svg';
import merge from '../../../images/icons/merge.svg';

export default ({ isActive, canMerge, handleClick, selectAll, isAllSelected = false }) => {
    return (
        <nav daya-cy="utlity-buttons-component" className={`package-builder-page_utility-buttons_wrapper hide-mobile`}>
            <button style={{ paddingRight: 0, paddingLeft: 4 }} className="package-builder-page_utility-buttons_btn-wrapper active">
                <label style={{ marginTop: 16 }} className='package-builder-page_custom-checkbox'>
                    <input onChange={(e) => selectAll(e)} checked={isAllSelected} type='checkbox' />
                    <span />
                </label>
            </button>
            <span className='divider'>|</span>
            {isActive ? <>
                <button title={'Merge selected packages'} disabled={!isActive && !canMerge} onClick={() => handleClick("MERGE")} className={`package-builder-page_utility-buttons_btn-wrapper ${isActive ? "active" : ""}`}>
                    <img style={{ height: 15 }} src={merge} alt='merge all' className={`package-builder-page_utility-buttons_icon ${isActive && canMerge ? "selectable" : ""}`} />
                </button>
                {/* <button data-cy="utility-buttons-delete" title={'Delete selected packages'} style={{ marginLeft: 8 }} disabled={!isActive} onClick={() => handleClick("DELETE")} className={`package-builder-page_utility-buttons_btn-wrapper ${isActive ? "active" : ""}`}>
                    <img src={deleteIcon} alt='delete all' className={`package-builder-page_utility-buttons_icon ${!isActive ? "selectable" : ""}`} />
                </button> */}
            </> : null}
        </nav >
    )
}